import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import {SsoComponent} from "./modules/login-page/sso/sso.component";


export const routes: Routes = [
  {
    path: "login",
    canActivate: [AuthGuard],
    loadChildren: () => import("./modules/login-page/login-page.module").then((module) => module.LoginPageModule)
  },
  {
    path: "forgot-password",
    loadChildren: () => import("./modules/login-page/forgot-password/forgot-password.module").then((m) => m.ForgotPasswordModule)
  },
  {
    path: "password-reset",
    loadChildren: () => import("./modules/login-page/reset-password/reset-password.module").then((m) => m.ResetPasswordModule)
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard'
  },
  {
    path: 'sso',
    canActivate: [AuthGuard],
    loadChildren: () => import("./modules/login-page/sso/sso.module").then(async (module) => {
      await new Promise(resolve => setTimeout(() => {
        localStorage.clear();
        console.log("Cleared local storage");
        resolve(void 0);
      }, 1000));
      return module.SsoModule;
    })

  },
  {
    //THIS ROUTE MUST BE ALWAYS LAST
    path: "",
    canActivate: [AuthGuard],
    loadChildren: () => import("./modules/pages/pages.module").then((module) => module.PagesModule),
  },
];
